export const unrestrictedRoutes = [
  "/auth",
  "/login",
  "/sign-up",
  "/updatepassword",
  "/forgotpassword",
  "/reset",
  "/record",
  "/auth1",
  "/verify",
  "/imaging/usthyroid-Preview",
  "/imaging/usabdominal-Preview",
  "/imaging/usabdominal-doppler-Preview",
  "/imaging/usaorta-Preview",
  "/imaging/bladderPreliminary-Preview",
  "/imaging/breastus-Preview",
  "/imaging/renalDopplerus-Preview",
  "/imaging/LwrExtrmVnsDpler-Preview",
  "/imaging/testicularUltrasound-Preview",
  "/imaging/prostateTransAbdominal-Preview",
  "/imaging/orthous-Preview",
  "/imaging/estim-Preview",
  "/imaging/uspelvic-Preview",
  '/imaging/echo-Preview',
  '/imaging/venous-Preview',
  '/imaging/carotid-Preview',
  '/imaging/arterial-Preview',
  "/imaging/strep-covid-flu-Preview",
  "/doc/homesleepq",
  "/patient",
  "/patient1111",
  "/patient-enrollment",
  // Public intake short links (care.brainymed.com/onboard/{odessa,frisco,code}):
  // patients are not logged in. They used to depend on the shared intake token
  // (?allowtoken=) to get past the sign-in redirect; the API now refuses that
  // token on staff routes, and these pages call only the public intake routes.
  // Exact names: "/onboard" alone would also match the staff "/onboard-emp".
  "/onboard-odessa",
  "/onboard-frisco",
  "/onboard-code",
  "/medTrack/",
  // Form Wizard patient link page (/f/#<practiceid>_<secret>). Trailing slash:
  // "/f" alone would also match /fax, /forms and /forms-preview (startsWith).
  "/f/",
];
